import template from './formas-pago.html';
import { FormActions } from 'core/services/form';
import formasPagoI18N from 'i18n/formas-pago/es.json';
import { formatErrorMessage } from 'core/util';

export let FormasPagoComponent = {
  templateUrl: template,
  selector: 'formasPago',
  bindings: {
    translations: '='
  },
  controller: FormasPagoCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(formasPagoI18N).concat(commonsI18N);

FormasPagoCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService'
];

function FormasPagoCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService) {

  var defaultColumnOrder = ['descripcion', 'formaDesembolso.value', 'estado.value'];

  BasicFactory.setup('formas-pago');
  const estadoQuery = Filter.path('tipo.codigo').eq('estado_activacion');
  const estadoUrl = encodeURI('valores?filter=' + JSON.stringify(estadoQuery));

  const formaDesembolsoQuery = Filter.path('tipo.codigo').eq('forma_desembolso');
  const formaDesembolsoUrl = encodeURI('valores?filter=' + JSON.stringify(formaDesembolsoQuery));

  this.options = {
    resource: 'formas-pago',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de formas de pago'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'descripcion', title: this.translations['Descripción'] },
      {
        data: 'formaDesembolso.value',
        title: this.translations['Forma Desembolso'],
        type: 'combo',
        filterUrl: formaDesembolsoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.formaDesembolso ? row.formaDesembolso.name : '<i>No establecido</i>';
        }
      },
      {
        data: 'estado.value',
        title: this.translations['Estado'],
        type: 'combo',
        filterUrl: estadoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.estado ? row.estado.name : '<i>No establecido</i>';
        }
      }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: onEdit.bind(this),
    onRemove: onRemove.bind(this),
    onView: onView.bind(this),
    canEditCondition: AuthorizationService.hasPermission.bind(this, 'update_formas_pago'),
    canRemoveCondition: AuthorizationService.hasPermission.bind(this, 'delete_formas_pago')
  };

  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.gotoForm = gotoForm.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de formas de pago']
    };
    this.form();
  };

  function mapStateToThis(state) {

    this.handleStatus(state);
    return { form: state.form };
  }

  function handleStatus(state) {
    if (state.form.removed) {
      ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }
    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

  }

  function gotoForm() {
    $state.go('home.formas-pago.new');
  }

  function onEdit(itemId) {
    $state.go('home.formas-pago.uid.edit', { uid: itemId });
  }

  function onRemove(itemId) {
    this.remove('formas-pago', itemId);
  }

  function onView(itemId) {
    $state.go('home.formas-pago.uid.view', { uid: itemId });
  }
}


// WEBPACK FOOTER //
// ./src/components/formas-pago/list/formas-pago.component.js